import { Navigate, Outlet, useOutletContext } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { P, hasAnyPermission } from "../../utils/permissions";

export default function ProtectedOrdersRoute({ children }) {
  const { permissions } = useAuth();
  const outletContext = useOutletContext();
  const canView = hasAnyPermission(
    permissions,
    P.ORDERS_READ_ALL,
    P.ORDERS_READ_VA,
    P.ORDERS_READ_ASSIGNED,
    P.ORDERS_READ_OWN
  );

  if (!canView) return <Navigate to="/access-denied" replace />;

  return children ?? <Outlet context={outletContext} />;
}
